import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import authService from "../../../../utils/services/authService";

import styles from "./developerUpdate.module.scss";

const DeveloperUpdate = ({ user }) => {
  const [newUserObject, setNewUserObject] = useState();
  const { name, bio, education, email, location, phone, gender } = user;

  const navigate = useNavigate();
  const userData = authService.getUserData();

  useEffect(() => {
    if (user) {
      setNewUserObject({
        name: name,
        bio: bio,
        education: education,
        email: email,
        location: location,
        phone: phone,
        gender: gender,
      });
    }
  }, []);

  const onChangeHandle = (e) => {
    const value = e.target.value;
    setNewUserObject({ ...newUserObject, [e.target.name]: value });
  };
  const submitHandle = async (e) => {
    e.preventDefault();

    const result = await authService
      .updateUser(user.role, user._id, newUserObject, userData)
      .then((res) => {
        if (res.data.success) {
          navigate("/admin/users");
        }
      });
  };

  // console.log(user);
  return (
    <section className={styles.devUpdateWrapper}>
      <h1 className={styles.devUpdateWrapper_heading}>Update developer</h1>
      <p className={styles.devUpdateWrapper_subHeading}>
        Update the fields required and click save
      </p>
      <form className={styles.updateForm}>
        {newUserObject &&
          Object.keys(newUserObject).map((key, index) =>
            newUserObject[key].length > 100 ? (
              <div key={index} className={styles.group}>
                <textarea
                  className={styles.group_textArea}
                  name={key}
                  id=""
                  cols="30"
                  rows="10"
                  onChange={(e) => {
                    onChangeHandle(e);
                  }}
                >
                  {newUserObject[key]}
                </textarea>
              </div>
            ) : (
              <div className={styles.group}>
                <input
                  className={styles.group_input}
                  type="text"
                  name={key}
                  value={newUserObject[key]}
                  onChange={(e) => {
                    onChangeHandle(e);
                  }}
                />
              </div>
            )
          )}
        <div className={styles.group}>
          <button
            className={styles.btn}
            type="submit"
            onClick={(e) => {
              submitHandle(e);
            }}
          >
            Save
          </button>
        </div>
      </form>
    </section>
  );
};

export default DeveloperUpdate;
